import { createContext, RefObject } from "react";
import {
  DropdownAlignment,
  DropdownPosition,
  IDropdownProps,
  RectPos,
} from "./Dropdown.interface";

export interface IDropdownContext
  extends Pick<
    IDropdownProps,
    | "opened"
    | "alignment"
    | "position"
    | "toggleToFlyoutOnMobile"
    | "theme"
    | "buttonTheme"
    | "toggleStrategy"
    | "drawingStrategy"
  > {
  buttonRef: RefObject<any>;
  listRef: RefObject<any>;
  currentPosition?: DropdownPosition;
  currentAlignment?: DropdownAlignment;
  pos?: RectPos;
  setPos?(newPos: RectPos);
  setOpened?(newOpened: IDropdownContext["opened"]): void;
  setCurrentAlignment?(alignment: DropdownAlignment): void;
  setCurrentPosition?(position: DropdownPosition): void;
}

export const DropdownContext = createContext<IDropdownContext>({
  buttonRef: null,
  listRef: null,
  opened: false,
});
